"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateInputField = void 0;
const react_1 = __importDefault(require("react"));
// import './DateInputField.scss';
// import {default as style} from './DateInputField.scss.json';
const package_1 = require("../package");
const InputField_1 = require("./InputField");
const DateInputField = (props) => {
    const stringValueToDate = (value) => {
        if (new Date(value).toString() !== 'Invalid Date' &&
            !isNaN(new Date(value))) {
            return new Date(value);
        }
        return null;
    };
    const dateToStringValue = (val) => {
        //if no value is currently stored, return empty string
        //this will render as 'dd-mm-yyyy' in the input field (or the equivalent in the user's local format)
        if (!val) {
            return '';
        }
        const date = new Date(val);
        const getY = date.getFullYear();
        const getM = String(date.getMonth() + 1).padStart(2, '0');
        const getD = String(date.getDate()).padStart(2, '0');
        //value of <input type=date> always needs to be yyyy-mm-dd, even though the user will see it in their own local format
        //see: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/date
        return `${getY}-${getM}-${getD}`;
    };
    return (react_1.default.createElement(InputField_1.InputField, Object.assign({ type: "date", preConvertValueFn: dateToStringValue, postConvertValueFn: stringValueToDate }, props)));
};
exports.DateInputField = DateInputField;
//register all components in this file
(0, package_1.registerPackageModule)(module);
//# sourceMappingURL=DateInputField.js.map